module.exports = __webpack_public_path__ + "img/loading_img.8fafce01.png";